export const tro30DataEn = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": "https://www.wm.com/us/en/dumpster-rental/30-yard",
      url: "https://www.wm.com/us/en/dumpster-rental/30-yard",
      name: "30 Yard Dumpster Rental | WM",
      primaryImageOfPage: {
        "@id": "https://www.wm.com/us/en/dumpster-rental/30-yard/#primaryimage",
      },
      image: {
        "@id": "https://www.wm.com/us/en/dumpster-rental/30-yard/#primaryimage",
      },
      thumbnailUrl:
        "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/30-yard/30-yd-header.jpg",
      description:
        "For large home or office renovation projects, our 30 yard dumpster rentals can handle your waste disposal needs. Schedule your rental online today.",
    },
    {
      "@type": "ImageObject",
      inLanguage: "en-US",
      "@id": "https://www.wm.com/us/en/dumpster-rental/30-yard/#primaryimage",
      url: "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/30-yard/30-yd-header.jpg",
      contentUrl:
        "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/30-yard/30-yd-header.jpg",
      width: 545,
      height: 327,
      caption: "30 yard dumpster dimensions",
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://www.wm.com/us/en/dumpster-rental/30-yard/#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.wm.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Dumpster Rental",
          item: "https://www.wm.com/us/en/dumpster-rental",
        },
        { "@type": "ListItem", position: 3, name: "30-Yard" },
      ],
    },
  ],
}

export const tro30ProductDataEn = {
  "@context": "https://schema.org",
  "@type": "Product",
  "@id": "https://www.wm.com/us/en/dumpster-rental/30-yard/#product",
  name: "30 Yard Dumpster Rental | WM",
  image:
    "https://www.wm.com/content/dam/wm/assets/dumpster-rental/index-pages/30-yard/30-yd-header.jpg",
  description:
    "One of our largest sizes, a 30 yard dumpster provides ample space for larger home renovation and office remodel projects. WM offers convenient online scheduling, delivery, and pickup management for all dumpster rentals.",
  url: "https://www.wm.com/us/en/dumpster-rental/30-yard",
  mainEntityOfPage: "https://www.wm.com/us/en/dumpster-rental/30-yard",
  isRelatedTo: [
    "10 Yard Dumpster",
    "12 Yard Dumpster",
    "15 Yard Dumpster",
    "20 Yard Dumpster",
    "40 Yard Dumpster",
  ],
  brand: { "@type": "Brand", "@id": "https://www.wm.com/#brand" },
}
